// Client-side image compression: shrinks 5MB → ~250KB before upload.
// Returns data URL (JPEG, max 1600px long edge, 0.8 quality).
export async function compressImageFile(file, { maxDim = 1600, quality = 0.8 } = {}) {
  if (!file.type.startsWith("image/")) {
    return await fileToDataUrl(file);
  }
  const dataUrl = await fileToDataUrl(file);
  const img = await loadImage(dataUrl);
  const { width, height } = fit(img.naturalWidth, img.naturalHeight, maxDim);
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);
  return canvas.toDataURL("image/jpeg", quality);
}

// Smaller preview (thumbnail) for list/card view
export async function makeThumbnail(dataUrl, { maxDim = 600, quality = 0.75 } = {}) {
  const img = await loadImage(dataUrl);
  const { width, height } = fit(img.naturalWidth, img.naturalHeight, maxDim);
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);
  return canvas.toDataURL("image/jpeg", quality);
}

function fileToDataUrl(file) {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = rej;
    img.src = src;
  });
}

function fit(w, h, maxDim) {
  if (w <= maxDim && h <= maxDim) return { width: w, height: h };
  const ratio = w / h;
  return ratio > 1
    ? { width: maxDim, height: Math.round(maxDim / ratio) }
    : { width: Math.round(maxDim * ratio), height: maxDim };
}
